import React, { useState } from "react";
import progress from "../../Assets/svg/progress.svg";
import SubmittedWelcome from "../SubmittedStatus";
import CongratsInfo from "../modules/CongratsInfo";
import { useSelector } from "react-redux";
import WaitListScreen from "./WaitListScreen";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useNavigate } from 'react-router-dom';

function ResultTab() {
  const tokenData = useSelector((state) => state.tokens.tokens);
  const navigate = useNavigate()

  // const registeredData = useSelector((state) => state.register.registeredData);
  const personalInfo = useSelector((state) => state.personal.personalInfo);

  const [status, setStatus] = useState("success");
  // if (status !== "success") {
  const toHelp = () => {
    let url = GetBaseUrl(window.location.href);
    // window.location.replace(url + "/application/help");
    navigate("/application/help");

  };
  return (
    <div className="result-tab">
      {tokenData.applicationData.applicationStatus !== "Awarded" && (
        <div className="progress-icon">
          <img src={progress} alt="progress" />
        </div>
      )}
      <div className={`status ${status} `}>
        {tokenData.applicationData.applicationStatus === "Awarded" ? (
          <CongratsInfo name={personalInfo?.firstName} />
        ) : tokenData.applicationData.applicationStatus === "Waitlisted" ? (
          <WaitListScreen />
        ) : (
          <div
            className="progress-title set-title"
            style={{ color: "#C4C4C4" }}
          >
            Hello {personalInfo?.firstName}!
            <span>Your application is currently under verification.</span>
            <span>
              You should receive an email on the status, as per progress.
            </span>
            <span>
              In case of any query, please reach us via{" "}
              <span className="highlight underline" onClick={() => toHelp()}>
                Help Page
              </span>
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

export default ResultTab;
